import PropTypes from 'prop-types'
import styles from './style.styl'

export default function WelcomeMessageCard({ children, ...rest }) {
  return (
    <div className={styles.WelcomeMessageCard} {...rest}>
      {children}
    </div>
  )
}
WelcomeMessageCard.propTypes = {
  children: PropTypes.node,
}



// WEBPACK FOOTER //
// ./src/scripts/components/shared/MessagePreviews/WelcomeMessage/WelcomeMessageCard/index.js